import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

interface MicroProjectionsPopupProps {
  /** Controls whether the popup is visible */
  open: boolean;
  /** User chose "Yes" -> stay on current screen and open a new micro target */
  onYes: () => void;
  /** User chose "No" -> move to the main screen */
  onNo: () => void;
  /** Optional: called when the dialog is dismissed (backdrop click / esc). Defaults to onNo. */
  onClose?: () => void;
  /** Optional override for the message text */
  message?: string;
}

const MicroProjectionsPopup: React.FC<MicroProjectionsPopupProps> = ({
  open,
  onYes,
  onNo,
  onClose,
  message = "Would you also like to set micro projections?",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose ?? onNo}
      aria-labelledby="micro-projections-title"
      aria-describedby="micro-projections-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="micro-projections-title">Micro Projections</DialogTitle>
      <DialogContent>
        <DialogContentText id="micro-projections-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onNo} color="secondary">
          No
        </Button>
        <Button onClick={onYes} color="secondary" variant="contained" autoFocus>
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MicroProjectionsPopup;
